// Lead magnets registry — add more objects here to spin up new /free/:slug pages.
// Each magnet is data-driven: same landing page template renders all of them.

export const LEAD_MAGNETS = {
  "marketing-clarity-checklist": {
    slug: "marketing-clarity-checklist",
    label: "Free Checklist",
    title: "The Marketing Clarity Checklist",
    subtitle:
      "A simple checklist to help you assess your marketing and identify your next priorities.",
    intro:
      "Most businesses don't need more marketing. They need clearer marketing. This one-page checklist gives you a quick, honest look at your audience, your message and your consistency, so you can spot where the real gaps are and decide what to focus on next.",
    bullets: [
      "A structured self-assessment across audience, message, branding and consistency",
      "A simple scoring system to see where your marketing is strong (and where it isn't)",
      "A prompt to define your next three priorities so you leave with a plan, not just a score",
    ],
    tint: "#ECE9FF",
    coverAlt: "Preview of The Marketing Clarity Checklist PDF",
    pdfUrl: "/downloads/marketing-clarity-checklist.pdf",
    mailchimpTag: "Magnet: Marketing Clarity Checklist",
    emailSubject: "Here's your Marketing Clarity Checklist",
  },
};

export const getLeadMagnet = (slug) => LEAD_MAGNETS[slug];
